import { EnumDynamicExportRunCounterTypes } from '@Model';
import { SelectOption } from '@synqo/frontend-component-library';

export function getExportCounterName(counterType: EnumDynamicExportRunCounterTypes): string {
    switch (counterType) {
        case EnumDynamicExportRunCounterTypes.InvoicesAccounting:
            return 'FiBu-Laufnummer';
        case EnumDynamicExportRunCounterTypes.Generic:
            return 'Exporte';
        case EnumDynamicExportRunCounterTypes.InvoiceSnapshots:
            return 'Rechnungen';
    }
}
export const exportCounterTypes: EnumDynamicExportRunCounterTypes[] = [
    EnumDynamicExportRunCounterTypes.InvoicesAccounting,
    EnumDynamicExportRunCounterTypes.Generic,
];

export const exportCounterTypesItems: SelectOption<EnumDynamicExportRunCounterTypes>[] = exportCounterTypes.map(
    (counterType) => ({
        name: getExportCounterName(counterType),
        value: counterType,
        label: getExportCounterName(counterType),
    }),
);
